import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 1,
  class: "ds-pagination__item ds-pagination__item--active",
  "aria-current": "page"
}
const _hoisted_3 = {
  key: 2,
  class: "ds-pagination__item ds-pagination__link-dots"
}

import { inject } from "vue";
import type { Theme } from "../types/theme";
import { themeKey } from "../pagination/pagination-injection-key";


export default /*@__PURE__*/_defineComponent({
  __name: 'pagination-item',
  props: {
    type: {},
    pageNumber: {},
    hideOnXs: { type: Boolean },
    onClickHandler: { type: Function }
  },
  setup(__props: any) {

const theme = inject<Theme>(themeKey);



return (_ctx: any,_cache: any) => {
  return (_ctx.type === 'item')
    ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: _normalizeClass(["ds-pagination__item", { 'ds-pagination__item--hide-xs': _ctx.hideOnXs }])
      }, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickHandler(_ctx.pageNumber))),
          class: _normalizeClass(["button button--sm button--secondary", { 'button--dark': _unref(theme) === 'dark' }]),
          "aria-label": `Přejít na stránku ${_ctx.pageNumber}`
        }, _toDisplayString(_ctx.pageNumber), 11, _hoisted_1)
      ], 2))
    : (_ctx.type === 'activeItem')
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.pageNumber), 1)
        ]))
      : (_ctx.type === 'dots')
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "ds-pagination__dots" }, "...", -1)
          ])))
        : _createCommentVNode("", true)
}
}

})